export default __webpack_public_path__ + "static/media/logo-tf.7bd182b8.png";